<template>
    <div class="possible-efforts-sub-menu">
        <div class="switcher">
            <div class="item" :class="{'selected': selectedItem === 'projects'}" @click="selectedItem = 'projects'">
                <span>{{ texts.projects.boksTekst }}</span>
                <!--<i class="far fa-fw fa-arrow-down" v-if="selectedItem === 'projects'"></i>
                <i class="far fa-fw fa-arrow-right" v-else></i>-->
            </div>
            <div class="item" :class="{'selected': selectedItem === 'aconto'}" @click="selectedItem = 'aconto'">
                <span>{{ texts.aconto.boksTekst }}</span>
                <!--<i class="far fa-fw fa-arrow-down" v-if="selectedItem === 'aconto'"></i>
                <i class="far fa-fw fa-arrow-right" v-else></i>-->
            </div>
            <div class="item" :class="{'selected': selectedItem === 'reminders'}" @click="selectedItem = 'reminders'">
                <span>{{ texts.reminders.boksTekst }}</span>
                <!--<i class="far fa-fw fa-arrow-down" v-if="selectedItem === 'reminders'"></i>
                <i class="far fa-fw fa-arrow-right" v-else></i>-->
            </div>
        </div>
        <div v-show="selectedItem === 'projects'">
            <div class="lg">
                {{ texts.projects.tykTekst1 }}
                {{ data.projects.value | currency }}
            </div>
            <div class="sub" v-html="texts.projects.tyndTekst1">
                {{ texts.projects.tyndTekst1 }}
            </div>
            <div class="g-table-wrapper" style="margin-top:15px;">

                <div class="table-title">
                    <d-tooltip placement="left" identifier="projects.openProjects" />
                    Ikke igangsatte opgaver
                </div>

                <vue-good-table
                    :columns="openColumns"
                    :rows="data.projects.table"
                    :search-options="searchOptions"
                    :pagination-options="paginationOptions"
                    :sort-options="openSortOptions"
                    :styleClass="styleClass"
                >
                    <div slot="emptystate">
                        Ingen data ...
                    </div>
                    <template slot="table-row" slot-scope="props">
                        <div class="coverage-cell" v-if="props.column.field == 'coverage_percent'">
                            {{ props.row.coverage_percent | coveragePercent }} 
                            <div
                                v-if="props.row.coverage_percent !== null"
                                class="coverage-indicator"
                                :class="{'bad': props.row.coverage_percent < $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.high.value}"
                            />
                        </div>
                        <div class="coverage-cell" v-else-if="props.column.field == 'status.name'">
                            {{ props.row.status.name }}
                            <div class="coverage-indicator status" :style="'background:#' + props.row.status.color + ';'" />
                        </div>
                        <div v-else-if="props.column.field == 'case_number'" class="table-column__ordernumber" style="text-align:left;">
                            {{ props.row.case_number }}
                        </div>
                        <div v-else-if="props.column.field == 'description'" class="table-column__description">
                            <budget-tooltip :project="props.row" v-if="props.row.calculation_price > 499 || props.row.calculation_cost > 499" />
                                <span :title="props.row.description">{{ props.row.description }}</span>
                            {{ props.row.description ? props.row.description : '-' }}
                        </div>
                        <div v-else-if="props.column.field == 'customer.name'" class="table-column__customer" :title="props.row.customer ? props.row.customer.name : '-'">
                            <i class="fal fa-map-marker-alt" style="margin-left:2px;" v-tooltip="{
                                content: '<b>Installationsadresse</b><br>' + ($auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)
                            }" v-if="props.row.installation_address"></i>
                            {{ props.row.customer ? props.row.customer.name : '-' }}
                        </div>
                        <div v-else-if="props.column.field == 'action'" class="g-table__action" @click="openExternalLink(props.row.external_id)">
                            <i class="fad fa-eye" />
                        </div>
                        <div v-else-if="props.column.field == 'start_date'">
                            {{ props.row.start_date | moment("DD. MMM YYYY") }}
                        </div>
                        <div v-else-if="props.column.field == 'type.name'" class="table-column__description" :title="props.row.type ? props.row.type.name : '-'">
                            {{ props.row.type ? props.row.type.name : '-' }}
                        </div>
                        <div v-else-if="props.column.field == 'minuba_external_id'">
                            <a :href="'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id" target="_blank" class="minuba-link">
                                <i class="fas fa-eye"></i>
                            </a>
                        </div>
                        <div v-else-if="props.column.field == 'expected_coverage'">
                            {{ props.row.expected_coverage | currency }}
                        </div>
                        <div v-else :title="props.formattedRow[props.column.field]">
                            {{ props.formattedRow[props.column.field] }}
                        </div>
                    </template>
                </vue-good-table>   

            </div>
            <div class="foot">
                <div class="button" @click="goToRoute('ProjectsOperations', 'openProjects')">
                    Gå til alle opgaver, der ikke er sat i gang &rarr;
                </div>
            </div>
        </div>
        <div v-show="selectedItem === 'aconto'">
            <div class="lg">
                {{ texts.aconto.tykTekst1 }}
                {{ data.aconto.value | currency }}
            </div>
            <div class="sub" v-html="texts.aconto.tyndTekst1">
                {{ texts.aconto.tyndTekst1 }}
            </div>
            <div class="g-table-wrapper" style="margin-top:15px;">
                <div class="table-title">
                    <d-tooltip placement="left" identifier="projects.ongoingProjects" />
                    Igangværende opgaver
                </div>
                <vue-good-table
                    :columns="acontoColumns"
                    :rows="data.aconto.table"
                    :search-options="searchOptions"
                    :pagination-options="paginationOptions"
                    :sort-options="acontoSortOptions"
                    :styleClass="styleClass"
                >
                    <div slot="emptystate">
                        Ingen data ...
                    </div>
                    <template slot="table-row" slot-scope="props">
                        <div class="coverage-cell" v-if="props.column.field == 'coverage_percent'">
                            {{ props.row.coverage_percent | coveragePercent }} 
                            <div
                                v-if="props.row.coverage_percent !== null"
                                class="coverage-indicator"
                                :class="{'bad': props.row.coverage_percent < $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.high.value}"
                            />
                        </div>
                        <div class="coverage-cell" v-else-if="props.column.field == 'status.name'">
                            {{ props.row.status.name }}
                            <div class="coverage-indicator status" :style="'background:#' + props.row.status.color + ';'" />
                        </div>
                        <div v-else-if="props.column.field == 'case_number'" class="table-column__ordernumber" style="text-align:left;">
                            {{ props.row.case_number }}
                        </div>
                        <div v-else-if="props.column.field == 'description'" class="table-column__description">
                            <budget-tooltip :project="props.row" v-if="props.row.calculation_price > 499 || props.row.calculation_cost > 499" />
                            <span :title="props.row.description ? props.row.description : '-'">{{ props.row.description ? props.row.description : '-' }}</span>
                        </div>
                        <div v-else-if="props.column.field == 'customer.name'" class="table-column__customer" :title="props.row.customer ? props.row.customer.name : '-'">
                            <i class="fal fa-map-marker-alt" style="margin-left:2px;" v-tooltip="{
                                content: '<b>Installationsadresse</b><br>' + ($auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)
                            }" v-if="props.row.installation_address"></i>
                            {{ props.row.customer ? props.row.customer.name : '-' }}
                        </div>
                        <div v-else-if="props.column.field == 'action'" class="g-table__action" @click="openExternalLink(props.row.external_id)">
                            <i class="fad fa-eye" />
                        </div>
                        <div v-else-if="props.column.field == 'start_date'">
                            {{ props.row.start_date | moment("DD. MMM YYYY") }}
                        </div>
                        <div v-else-if="props.column.field == 'type.name'" class="table-column__description" :title="props.row.type ? props.row.type.name : '-'">
                            {{ props.row.type ? props.row.type.name : '-' }}
                        </div>
                        <div v-else-if="props.column.field == 'invoices_total'">
                            <span v-if="props.row.invoices_total > 0">{{ props.row.invoices_total | currency }}</span>
                            <span v-else>-</span>
                        </div>
                        <div v-else-if="props.column.field == 'total_expenses'">
                            <span v-if="props.row.total_expenses > 0">
                                {{ props.row.total_expenses | currency }}
                            </span>
                            <span v-else>-</span>
                        </div>
                        <div v-else-if="props.column.field == 'value'">
                            <project-tooltip :valueBased="true" :project="props.row" />
                            {{ props.row.value | currency }}
                        </div>
                        <div v-else-if="props.column.field == 'value_with_avg_cp'">
                            <project-tooltip :valueBased="true" :valueBasedWithCP="true" :project="props.row" />
                            {{ props.row.value_with_avg_cp | currency }}
                        </div>
                        <div v-else-if="props.column.field == 'minuba_external_id'">
                            <a :href="'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id" target="_blank" class="minuba-link">
                                <i class="fas fa-eye"></i>
                            </a>
                        </div>
                        <div v-else :title="props.formattedRow[props.column.field]">
                            {{ props.formattedRow[props.column.field] }}
                        </div>
                    </template>
                </vue-good-table>
            </div>
            <div class="foot">
                <div class="button" @click="goToRoute('ProjectsOperations', 'ongoingProjects')">
                    Gå til alle igangværende opgaver &rarr;
                </div>
            </div>
        </div>
        <div v-show="selectedItem === 'reminders'">
            <div class="lg">
                {{ texts.reminders.tykTekst1 }}
                {{ data.reminders.value | currency }}
            </div>
            <div class="sub" v-html="texts.reminders.tyndTekst1">
                {{ texts.reminders.tyndTekst1 }}
            </div>
            <div class="g-table-wrapper" style="margin-top:15px;">
                <div class="table-title">
                    <d-tooltip identifier="oekonomi.unpaidInvoices" placement="left" />
                    Fakturaer, der ikke er betalt
                </div>

                <vue-good-table
                    :columns="unpaidInvoicesColumns"
                    :rows="data.reminders.table"
                    :search-options="searchOptions"
                    :pagination-options="paginationOptions"
                    :sort-options="unpaidInvoicesSortOptions"
                    :styleClass="styleClass"
                >
                    <div slot="emptystate">
                        Ingen data ...
                    </div>
                    <template slot="table-row" slot-scope="props">
                        <div v-if="props.column.field == 'description'" class="table-column__description" :title="props.row.description">
                            {{ props.row.description }}
                        </div>
                        <div v-else-if="props.column.field == 'invoice_number'" style="text-align:left;">
                            {{ props.row.invoice_number ? props.row.invoice_number : '-' }}
                        </div>
                        <div v-else-if="props.column.field == 'external_id'" class="table-column__external-id">
                            {{ props.row.external_id }}
                        </div>
                        <div v-else-if="props.column.field == 'due_at'">
                            {{ props.row.due_at | moment("DD. MMM YYYY") }}
                        </div>
                        <div v-else-if="props.column.field == 'amount'" style="text-align:left;">
                            {{ props.row.amount | currency }}
                        </div>
                        <div v-else-if="props.column.field == 'paid'" style="text-align:left;">
                            <span v-if="props.row.paid">
                                Betalt
                            </span>
                            <span v-else>
                                Ikke betalt
                            </span>
                        </div>
                        <div v-else-if="props.column.field == 'minuba_external_id'">
                            <a :href="'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id" target="_blank" class="minuba-link">
                                <i class="fas fa-eye"></i>
                            </a>
                        </div>
                        <div v-else :title="props.formattedRow[props.column.field]">
                            {{ props.formattedRow[props.column.field] }}
                        </div>
                    </template>
                </vue-good-table>

            </div>
            <div class="foot">
                <div class="button" @click="goToRoute('EconomyOperations', 'unpaidInvoices')">
                    Gå til alle fakturaer, der ikke er betalt &rarr;
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['selectedBox', 'data', 'totalOpenValue', 'totalAcontoValue', 'totalRemindersValue', 'texts'],
    data () {
        return {
            selectedItem: 'projects',
            openColumns: [
                { label: 'Ordre', field: 'case_number', type: 'number' },
                { label: 'Opgavetype', field: 'type.name', type: 'string' },
                { label: 'Opgave', field: 'description', type: 'string' },
                { label: 'Kunde', field: 'customer.name', type: 'string' },
                { label: 'Startdato', field: 'start_date', type: 'string' },
                { label: 'Forv. DB', field: 'expected_coverage', type: 'number' },
                { label: 'Status', field: 'status.name', type: 'string' }
            ],
            acontoColumns: [
                { label: 'Ordre', field: 'case_number', type: 'number' },
                { label: 'Kunde', field: 'customer.name', type: 'string' },
                { label: 'Opgavetype', field: 'type.name', type: 'string' },
                { label: 'Opgave', field: 'description', type: 'string' },
                { label: 'Aconto', field: 'invoices_total', type: 'number' },
                { label: 'Timer/materialer, kostpris', field: 'total_expenses', type: 'number' },
                { label: 'Værdi, salgspris', field: 'value_with_avg_cp', type: 'number' },
                { label: 'Status', field: 'status.name', type: 'string' }
            ],
            unpaidInvoicesColumns: [
                { label: 'Faktura', field: 'invoice_number', type: 'number', width: '10%', align: 'left', sortable: true },
                { label: 'Ordre', field: 'external_project_id', type: 'string', width: '10%', align: 'left', sortable: true },
                { label: 'Kunde', field: 'customer_name', type: 'string', width: '15%', sortable: true },
                { label: 'Beskrivelse', field: 'description', type: 'string', width: '20%', sortable: true },
                { label: 'Forfaldsdato', field: 'due_at', type: 'string', width: '10%', sortable: true },
                { label: 'Beløb', field: 'amount', type: 'number', width: '15%', sortable: true },
                { label: 'Status', field: 'paid', type: 'boolean', width: '10%', sortable: true }
            ],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 10,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true
            },
            openSortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'expected_coverage',
                    type: 'desc'
                }
            },
            acontoSortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'value_with_avg_cp',
                    type: 'desc'
                }
            },
            unpaidInvoicesSortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'amount',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        }
    },
    mounted () {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.openColumns.push({ label: 'Åbn', field: 'minuba_external_id' })
            this.acontoColumns.push({ label: 'Åbn', field: 'minuba_external_id' })
            this.unpaidInvoicesColumns.push({ label: 'Åbn', field: 'minuba_external_id' })
        }
    },
    methods: {
        goToRoute (parent, child) {
            this.$router.push({
                name: parent,
                params: {
                    selectedItem: child
                },
                query: {
                    tab: child
                }
            })
        }
    },
    watch: {
        selectedBox () {
            if (this.selectedBox) {
                this.selectedItem = this.selectedBox
            } else {
                this.selectedItem = 'projects'
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// economy.vue?62fb6424